interface ActionTypes {
  SET_IS_OPEN_BASE_MAP_PANEL: string;
  SET_IS_OPEN_MAP_LOC_SEARCH_PANEL: string;
  SET_MAP_SEARCH_WITH_EXTENT_ZOOM: string;
}

export const MapActionTypes: ActionTypes = {
  SET_IS_OPEN_BASE_MAP_PANEL: '@@SET_IS_OPEN_BASE_MAP_PANEL',
  SET_IS_OPEN_MAP_LOC_SEARCH_PANEL: '@@SET_IS_OPEN_MAP_LOC_SEARCH_PANEL',
  SET_MAP_SEARCH_WITH_EXTENT_ZOOM: '@@SET_MAP_SEARCH_WITH_EXTENT_ZOOM'
};

export interface MapState {
  isOpenBaseMapPanel?: boolean;
  isOpenMapLocSearchPanel?: boolean;
  mapSearchWithExtentZoom: boolean[];
}

export default MapActionTypes;
